/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dialog[_ngcontent-%COMP%]{z-index:1000;position:fixed;right:0;left:0;top:50%;transform:translateY(-50%);margin-right:auto;margin-left:auto;min-height:300px;overflow:auto;width:90%;max-width:850px;background-color:#fff;box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 13px 19px 2px rgba(0,0,0,.14),0 5px 24px 4px rgba(0,0,0,.12)}.header[_ngcontent-%COMP%]{height:72px;background-color:#101244;padding:20px}.modal-body[_ngcontent-%COMP%]{background-color:red}.close[_ngcontent-%COMP%]{color:#fff;opacity:1;padding:0!important}"];
export { styles as styles };
